/**
 * AI:
 * Status: 'in progress'
 * Type: Component
 * SubType: ObjectBaseModeComponent
 * Reason: Full (object page) view of the lg.LogicMappingTable object component — four navigation
 *         sections: master data with the configuration warnings, entries, partner overrides, quick test.
 */
import {Component, OnInit} from '@angular/core';
import {LgLogicMappingTableObjectBaseComponent} from '../lg-logic-mapping-table-object-base.component';

/**
 * Wide view of the mapping-table object component, used by the object page `lg/mapping-table/:id`.
 *
 * <h2>Why this view renders its own navigation rail</h2>
 * `ObjectPageComponent` creates an object component and nothing else — it renders no rail. The drawer
 * host `mvs-object` DOES render one, but only from the items an object component emits. So exactly one
 * of the two must own the rail per view: the side view emits and lets the host draw it, this view draws
 * it itself and stays silent. {@link handleNavigationItemsChange} is overridden to no-op for that reason —
 * emitting here would produce a second rail above the one in the template.
 */
@Component({
    selector: 'mvs-lg-logic-mapping-table-object-component-full',
    templateUrl: 'lg-logic-mapping-table-object-full.component.html',
    standalone: false
})
export class LgLogicMappingTableObjectFullComponent extends LgLogicMappingTableObjectBaseComponent implements OnInit {

    override loadSideBarMenuItems(): void {
        this.navigationItems = [
            {
                label: 'Übersicht',
                action: LgLogicMappingTableObjectBaseComponent.NAV_OVERVIEW,
                tooltip: 'Stammdaten, Fallback-Verhalten und Rückzug der Tabelle',
                icon: 'fa-regular fa-circle-info',
                toggleable: false,
                default: true
            },
            {
                label: 'Einträge',
                action: LgLogicMappingTableObjectBaseComponent.NAV_ENTRIES,
                tooltip: 'Zuordnungen von Quellwert auf Zielwert',
                icon: 'fa-regular fa-list',
                toggleable: false,
                default: false
            },
            {
                label: 'Partner-Overrides',
                action: LgLogicMappingTableObjectBaseComponent.NAV_OVERRIDES,
                tooltip: 'Partnerspezifische Zuordnungen, die vor den Standardeinträgen greifen',
                icon: 'fa-regular fa-user-gear',
                toggleable: false,
                default: false
            },
            {
                label: 'Schnelltest',
                action: LgLogicMappingTableObjectBaseComponent.NAV_QUICK_TEST,
                tooltip: 'Einen Quellwert gegen diese Tabelle auflösen',
                icon: 'fa-regular fa-gauge-high',
                toggleable: false,
                default: false
            }
        ];

        this.activeNavigationItem = this.navigationItems[0];
    }

    /**
     * Suppresses the upward emission of the navigation items.
     *
     * This view draws its own rail (see the class comment). Emitting would make the drawer host draw a
     * second one directly above it.
     */
    override handleNavigationItemsChange(): void {
    }

}
